import classNames from "classnames";
import {
	PageSectionProps,
	TitleAndContentProps,
} from "../../../../../constants/pageSectionTypes";
import MarkdownRenderer from "../../../../common/MarkdownRenderer/MarkdownRenderer";
import smashImage from "../../../../imagenes/about-us/Smack_yellow.png";
import ContentList from "../../../../ui/ContentList/ContentList";
import ContentListItem from "../../../../ui/ContentListItem/ContentListItem";
import "./OurValues.scss";

export type OurValuesContent = {
	enabled: boolean;
	title: string;
	items: TitleAndContentProps[];
};

const OurValues = ({
	sectionContent,
	className,
}: PageSectionProps<OurValuesContent>) => {
	return (
		<section className={classNames("our-values", className)}>
			<MarkdownRenderer>{sectionContent.title}</MarkdownRenderer>
			<ContentList className="content-list--grid">
				{sectionContent.items.map((item, index) => (
					<ContentListItem key={index} className="content-list__item--text">
						{item.content === "Smack" ? (
							<div className="content-list__item--img-container">
								<img src={smashImage} alt="Smack" />
							</div>
						) : (
							<MarkdownRenderer>{item.content}</MarkdownRenderer>
						)}
					</ContentListItem>
				))}
			</ContentList>
		</section>
	);
};

export default OurValues;
